document.addEventListener("product:variant-change", e => {
  console.log("variant changed ", e);
  const className = e.detail.sectionId.length == 0 ? "product-information" : "stickyaddtocart";
  let compareAtPriceElem = document.querySelector(".stickyaddtocart #price- > span > del > span > span");
  let priceElem = document.querySelector(".stickyaddtocart #price- > span > ins > span > span");
  let afterPayPriceElem = document.querySelector(".product-information--inner #afterpay-price .money");
  const priceFormat = window.theme.settings.money_with_currency_format;
  if(!compareAtPriceElem) {
    compareAtPriceElem = document.querySelector(".stickyaddtocart #price- > span > del > span");
  }
  
  if(!priceElem) {
    priceElem = document.querySelector(".stickyaddtocart #price- > span > ins > span");
  }
  if(!afterPayPriceElem) {
    afterPayPriceElem = document.querySelector(".product-information--inner #afterpay-price");
  }
  
  document.querySelector(`.${className} [value='${e.detail.variant.option1}']`).click();
  compareAtPriceElem.innerHTML = formatMoney(e.detail.variant.compare_at_price, priceFormat) 
  priceElem.innerHTML = formatMoney(e.detail.variant.price, priceFormat)
  document.querySelector(".stickyaddtocart #afterpay-price").innerHTML = formatMoney(e.detail.variant.price / 4.0, priceFormat);
  document.querySelector(".stickyaddtocart #afterpay-price").innerHTML = formatMoney(e.detail.variant.price / 4.0, priceFormat);
  afterPayPriceElem.innerHTML = formatMoney(e.detail.variant.price / 4.0, priceFormat);
  
});

document.querySelectorAll(".afterpay-action").forEach(elem => {
  elem.addEventListener("click", (e) => {
    document
      .querySelector("square-placement")
      ?.shadowRoot
      .querySelector("button.afterpay-logo")
      ?.click();
  })
});

document.addEventListener("cart:line-item:removed", e => {
  document.querySelector("#Cart-Drawer")?.updateQuantity(e.detail.target.dataset.index, '0')
});

function initializeCountdown() {
    const countdownElement = document.getElementById("countdown");
    const targetDate = countdownElement.getAttribute("data-target-date");
    const countdownHours = countdownElement.getAttribute("data-target-hours");

    let targetTime;

    if (targetDate) {
        // Parse the target date if provided
        targetTime = new Date(targetDate).getTime();
    } else if (countdownHours) {
        // Calculate the target time based on the current time and countdown hours
        //const countdownDuration = parseInt(countdownHours) * 60 * 60 * 1000; // Convert hours to milliseconds
        //const now = Date.now();
      
        const today = new Date(); 
        const dynamicDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${(today.getDate()).toString().padStart(2, '0')}T23:59:59`; // Append the fixed time to today's date
        targetTime = new Date(dynamicDate).getTime();
    } else {
        console.error("Either data-target-date or data-target-hours must be provided.");
        return;
    }

    function updateCountdown() {
        const now = Date.now();
        const timeRemaining = targetTime - now;

        if (timeRemaining >= 0) {
            const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
            const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24).toString().padStart(2, '0');
            const minutes = Math.floor((timeRemaining / (1000 * 60)) % 60).toString().padStart(2, '0');
            const seconds = Math.floor((timeRemaining / 1000) % 60).toString().padStart(2, '0');

            // Update the countdown display
            countdownElement.innerHTML = `
                <strong>${days}</strong> Day <span>:</span>
                <strong>${hours}</strong> Hrs <span>:</span>
                <strong>${minutes}</strong> Mins <span>:</span>
                <strong>${seconds}</strong> Sec
            `;

            // Repeat every second
            setTimeout(updateCountdown, 1000);
        } else {
            if (countdownHours) {
                // Restart the countdown for countdownHours
        const today = new Date(); 
        const dynamicDate = `${today.getFullYear()}-${(today.getMonth()).toString().padStart(2, '0')}-${(today.getDate()).toString().padStart(2, '0')}T23:59:59`; // Append the fixed time to today's date
        targetTime = new Date(dynamicDate).getTime();
            } else {
                // Countdown ended for targetDate
                countdownElement.innerHTML = `
                    <strong>00</strong> Day <span>:</span>
                    <strong>00</strong> Hrs <span>:</span>
                    <strong>00</strong> Mins <span>:</span>
                    <strong>00</strong> Sec
                `;
                console.log("Countdown complete!");
            }
        }
    }

    updateCountdown();
}

document.addEventListener("DOMContentLoaded", initializeCountdown);

document.addEventListener('DOMContentLoaded', function () {
    const squarePlacement = document.querySelector('square-placement');
    const productPriceContainer = document.querySelector('.stickyaddtocart .product-price-container');
    if (squarePlacement && productPriceContainer) {
        const clonedElement = squarePlacement.cloneNode(true);
        productPriceContainer.appendChild(clonedElement);
    }
});


document.addEventListener('DOMContentLoaded', function () {
  const textButtons = document.querySelectorAll('.template-product .text-button');
  const productATC = document.querySelector('.product button#AddToCart');

  if (textButtons.length > 0 && productATC) {
    textButtons.forEach(function (textButton) {
      textButton.addEventListener('click', function (e) {
        e.preventDefault();
        textButton.classList.add('loading');
        const variantId = productATC.getAttribute('data-vid');
        if (variantId) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Error adding item to cart');
              }
              return response.json();
            })
            .then(data => {
              textButton.classList.remove('loading');
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
             if (document.getElementById('Cart-Drawer')) {
               console.log('trigger');
                initiateFlicktyInDrawer();
                 dispatchCustomEvent('cart-drawer:open');
                document.getElementById('Cart-Drawer').open();
                 setTimeout(function(){
                   initiateFlicktyInDrawer();
                 },600);
             }
              console.log('Item added to cart:', data);
            })
            .catch(error => {
              textButton.classList.remove('loading');
              console.error('Failed to add item to cart:', error);
            });
        } else {
          textButton.classList.remove('loading');
          console.error('Variant ID not found on AddToCart button.');
        }
      });
    });
  }
});


function setSliderHeightToMax(slider) {
    slider.cells.forEach(cell => cell.element.style.height = '');
        
    let heights = slider.cells.map(cell => cell.element.offsetHeight),
        max = Math.max.apply(Math, heights);
    
    slider.cells.forEach(cell => cell.element.style.height = max + 'px');
}

function blogSlider(){
  let elem = document.querySelector('.blog-posts .blog-slider');
  if (elem) {
    let flkty = new Flickity(elem, {
      cellAlign: 'left',
      prevNextButtons: false,
      wrapAround: false,
      pageDots: false,
      draggable: true,
      contain: true
    });

    let snext = document.querySelector('.blog-slider-nav .next-article');
    let sprev = document.querySelector('.blog-slider-nav .prev-article');

    function updateNavButtons() {
      if (flkty.selectedIndex === 0) {
        sprev?.classList.add('disabled'); // Add 'disabled' class to prev button if first slide
      } else {
        sprev?.classList.remove('disabled'); // Remove 'disabled' class if not first slide
      }

      if (flkty.selectedIndex === flkty.slides.length - 1) {
        snext?.classList.add('disabled'); // Add 'disabled' class to next button if last slide
      } else {
        snext?.classList.remove('disabled'); // Remove 'disabled' class if not last slide
      }
    }
    
    snext.addEventListener('click', function() {
      flkty.next();
      updateNavButtons();
    });
    
    sprev.addEventListener('click', function() {
      flkty.previous();
      updateNavButtons();
    });
    updateNavButtons();
    setTimeout(function(){
      flkty.resize(); 
      updateNavButtons();
    },500);
  }
}

function initializeAFBFlickity() {
  let elem = document.querySelector('.afb-slider');
  if (elem) {
    let flkty = new Flickity(elem, {
      cellAlign: 'left',
      prevNextButtons: false,
      wrapAround: false,
      pageDots: false,
      draggable: true,
      contain: true
    });

    let snext = document.querySelector('.csnav.csnav-next');
    let sprev = document.querySelector('.csnav.csnav-prev');

    // Function to check if the slider is at the first or last slide
    function updateNavButtons() {
      if (flkty.selectedIndex === 0) {
        sprev?.classList.add('disabled'); // Add 'disabled' class to prev button if first slide
      } else {
        sprev?.classList.remove('disabled'); // Remove 'disabled' class if not first slide
      }

      if (flkty.selectedIndex === flkty.slides.length - 1) {
        snext?.classList.add('disabled'); // Add 'disabled' class to next button if last slide
      } else {
        snext?.classList.remove('disabled'); // Remove 'disabled' class if not last slide
      }
    }

    // Next button listener
    snext?.addEventListener('click', function () {
      flkty.next();
      updateNavButtons(); // Update button states after navigation
    });

    // Previous button listener
    sprev?.addEventListener('click', function () {
      flkty.previous();
      updateNavButtons(); // Update button states after navigation
    });

    // Initial button state update
    updateNavButtons();

    // Trigger resize after ensuring content layout
    window.addEventListener('load', function () {
      flkty.resize();
      updateNavButtons(); // Ensure button states are correct after resize
    });
  }
}



function initializeThumbSlider() {
  var thumbs = document.querySelector('#Product-Thumbnails');

  if (thumbs) {
    var thumbCount = thumbs.childElementCount;

    // Clone all thumbnails if fewer than 6
    if (thumbCount < 6) {
      for (var i = 0; i < 6; i++) {
        var clone = thumbs.children[i % thumbCount].cloneNode(true);
        clone.classList.add('cloned-thumb'); // Add 'cloned-thumb' class
        thumbs.appendChild(clone);
      }
    }

    var thumbSlider = new Flickity(thumbs, {
      cellAlign: 'left',
      asNavFor: document.querySelector('#Product-Slider'),
      pageDots: false,
      wrapAround: false,
      contain: true,
      prevNextButtons: true
    });

    setTimeout(function () {
      thumbSlider.resize();

      let mainSlider = document.querySelector('#Product-Slider').flickityInstance;

      mainSlider.on('change', function (index) {
        thumbSlider.select(index);
      });

      thumbSlider.on('change', function (index) {
        mainSlider.select(index);
      });

    }, 500);
  }
}




function initializeVideoSlider() {
  // var videos = document.querySelector('.video-images-slides');

  // if (videos) {
  //   // var videoSlider = new Flickity(videos, {
  //   //   cellAlign: 'center',
  //   //   pageDots: false,
  //   //   initialIndex: 2,
  //   //   prevNextButtons: false,
  //   //   contain: true,
  //   //   on: {
  //   //     ready: function() {
  //   //       setSliderHeightToMax(this); // Set the height of the slider when it's ready
  //   //     }
  //   //   }
  //   // });

  //   // Resize the slider height when the window is resized
  //   window.addEventListener('resize', function() {
  //     setSliderHeightToMax(videoSlider);
  //   });

  //   window.addEventListener("load", () => {
  //     setTimeout(function() {
  //       videoSlider.resize(); 
  //     }, 500);
  //   });
    
  // }

  function initVideoSlider() {
  const $slider = $('.video-images-slides');
  const screenWidth = window.innerWidth;

  if (screenWidth <= 767) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: false,
        centerMode: true,
        variableWidth: false,
        adaptiveHeight: false,
        infinite: false,
        initialSlide: 1,
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

// Run on page load and on resize
$(document).ready(function () {
  initVideoSlider();
  $(window).on('resize', initVideoSlider);
});

  

  // Handle play/pause functionality when clicking the play/pause button
  var playPauseButtons = document.querySelectorAll('.video-image-slide .playpausebtn');
  playPauseButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var parentSlide = this.closest('.video-image-slide');
      var video = parentSlide.querySelector('video'); // Get the video inside the parent slide

      if (parentSlide.classList.contains('is-playing')) {
        // If the parent has 'is-playing', pause the video and remove the class
        video.pause();
        parentSlide.classList.remove('is-playing');
      } else {
        // If the parent doesn't have 'is-playing', pause all videos in the slider first
        var allVideos = document.querySelectorAll('.video-image-slide video');
        allVideos.forEach(function(v) {
          v.pause(); // Pause all videos
        });

        video.play(); // Play the current video's sibling video
        parentSlide.classList.add('is-playing'); // Add the 'is-playing' class to the parent
      }
    });
  });

  // Detect when a video is paused and remove 'is-playing' class from its parent
  var allVideos = document.querySelectorAll('.video-image-slide video');
  allVideos.forEach(function(video) {
    video.addEventListener('pause', function() {
      var parentSlide = video.closest('.video-image-slide');
      if (parentSlide && parentSlide.classList.contains('is-playing')) {
        parentSlide.classList.remove('is-playing'); // Remove the 'is-playing' class from the parent
      }
    });
  });
}




document.addEventListener("DOMContentLoaded", function(){
  try { initializeAFBFlickity(); } catch(e){}
  try { initializeThumbSlider(); } catch(e){}
  try { initializeVideoSlider(); } catch(e){}
  try { blogSlider(); } catch(e){}
});




function openTab(tabId) {
  // Remove active class from all tab buttons
  const buttons = document.querySelectorAll('.cstm-tabs-btn');
  buttons.forEach((btn) => btn.classList.remove('active'));

  // Remove active class from all tab contents
  const contents = document.querySelectorAll('.cstm-tabs-content');
  contents.forEach((content) => content.classList.remove('active'));

  // Add active class to the selected tab button
  document.querySelector(`.cstm-tabs-btn[onclick="openTab('${tabId}')"]`).classList.add('active');

  // Add active class to the selected tab content
  document.getElementById(tabId).classList.add('active');
}



// Select all elements with .logo-list__inner
// const logoListInners = document.querySelectorAll('.logo-list .logo-list__inner');

// // Map to store Flickity instances
// const flickityInstances = new Map();

// // Function to initialize or destroy Flickity for all elements
// function toggleFlickity() {
//   const screenWidth = window.innerWidth;

//   logoListInners.forEach((logoListInner, index) => {
//     if (screenWidth <= 767) {
//       // Initialize Flickity if not already initialized
//       if (!flickityInstances.has(index)) {
//         const flickityInstance = new Flickity(logoListInner, {
//           cellAlign: 'center',
//           wrapAround: true,
//           pageDots: false,
//           prevNextButtons: false,
//           autoPlay: 2000
//         });
//         flickityInstances.set(index, flickityInstance);
//       }
//     } else {
//       // Destroy Flickity if initialized
//       if (flickityInstances.has(index)) {
//         const flickityInstance = flickityInstances.get(index);
//         flickityInstance.destroy();
//         flickityInstances.delete(index); // Remove the instance
//       }
//     }
//   });
// }

// // Add event listener to handle resize
// window.addEventListener('resize', toggleFlickity);

// // Run on initial load
// toggleFlickity();
function toggleSlickSlider() {
  const $slider = $('.logo-list__inner');
  const screenWidth = window.innerWidth;

  if (screenWidth <= 1024) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: screenWidth <= 1024 ? 1 : 2,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        touchThreshold: 100
      });
    } else {
      // Update slidesToShow on resize
      $slider.slick('slickSetOption', 'slidesToShow', screenWidth <= 767 ? 1 : 2, true);
    }
  } else if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
}

// $(document).ready(function () {
  toggleSlickSlider();

  $(window).on('resize', function () {
    toggleSlickSlider();
  });
// });



document.querySelectorAll('.c-popup-wrapper').forEach((popup) => {

  const triggerSelector = popup.getAttribute('data-trigger');
  const triggerElement = document.querySelector(triggerSelector);

  if (triggerElement) {
    triggerElement.addEventListener('click', (event) => {
      event.preventDefault();
      popup.classList.add('active');
      document.body.classList.add('popout-open');
    });
  } else {
    console.warn(`Trigger element not found for selector: ${triggerSelector}`);
  }
  
});


document.querySelectorAll('.c-pop-close').forEach((closeButton) => {
  closeButton.addEventListener('click', () => {
    document.querySelectorAll('.c-popup-wrapper').forEach((popup) => {
      popup.classList.remove('active');
    });
    document.body.classList.remove('popout-open');
  });
});


function responsiveMove(elementSelector, targetSmallScreenSelector, targetLargeScreenSelector, breakpoint = 767, position = 'before') {
  const element = document.querySelector(elementSelector);
  const targetSmallScreen = document.querySelector(targetSmallScreenSelector);
  const targetLargeScreen = document.querySelector(targetLargeScreenSelector);

  if (!element || !targetSmallScreen || !targetLargeScreen) {
    console.warn('Element or targets not found for responsiveMove:', { elementSelector, targetSmallScreenSelector, targetLargeScreenSelector });
    return;
  }

  function moveElement() {
    const screenWidth = window.innerWidth;

    if (screenWidth <= breakpoint) {
      // Move element to the specified position relative to the small screen target
      if (position === 'before') {
        targetSmallScreen.parentNode.insertBefore(element, targetSmallScreen);
      } else if (position === 'after') {
        targetSmallScreen.parentNode.insertBefore(element, targetSmallScreen.nextSibling);
      }
    } else {
      // Move element to the specified position relative to the large screen target
      if (position === 'before') {
        targetLargeScreen.parentNode.insertBefore(element, targetLargeScreen);
      } else if (position === 'after') {
        targetLargeScreen.parentNode.insertBefore(element, targetLargeScreen.nextSibling);
      }
    }
  }

  // Add resize event listener
  window.addEventListener('resize', moveElement);

  // Run on initial load
  moveElement();
}


function moveResponsiveElements(){
  responsiveMove('.pfp-features', '.pdp-badges', 'variant-selects', 767, 'before');
  responsiveMove('.customer-review .cr-c', '.customer-review .cr-image img', '.customer-review .cr-content-review', 767, 'after');
  responsiveMove('.therapy-works .cr-c', '.therapy-works .customer-review .cr-image img', '.therapy-works .cr-content-review', 767, 'after');
  responsiveMove('.afterbefore-wraper .custom-nav', '.afb-right .afb-slider', '.afterbefore-wraper .afb-content-text', 767, 'after');
  responsiveMove('.cstmtans-left > .button', '.cstm-tabs-container .cstm-tabs-contents', '.cstmtans-left .cstmtab-content', 767, 'after');
  responsiveMove('.review-homepage.text-with-icons .text-with-icons__block-content h6', '.section-text-with-icons .review-homepage.text-with-icons .text-with-icons__icon img', '.review-homepage.text-with-icons .text-with-icons__block-content p', 767, 'before');
  responsiveMove('.blog-slider-nav', '.blog-posts.blog-section > .text-center > .button', '.blog-header-wrap.has-slider .section-header', 767, 'after');
  responsiveMove('.faq-section .bottom-btn-rating', '.faq-sec-wrapper', '.faq-sec-wrapper .customer-review', 767, 'after');
}

moveResponsiveElements();


document.addEventListener('shopify:section:load', function(event) {
  initializeAFBFlickity();
  initializeThumbSlider();
  initializeVideoSlider();
  moveResponsiveElements();
  initializeCountdown();
  blogSlider();
});



  
  const stickyCart = document.querySelector('#sticky-add-to-cart');
  const addToCartBtn = document.querySelector('#AddToCart'); // Main Add to Cart button
  const stickyAddToCartBtn = document.querySelector('#sticky-add-to-cart-button');
  const variantSelectors = document.querySelectorAll('form[action="/cart/add"] select, form[action="/cart/add"] input[type="radio"]');
  const stickyVariantOptions = document.querySelector('#sticky-variant-options');


  variantSelectors.forEach((selector) => {
    const clone = selector.cloneNode(true);
    clone.addEventListener('change', syncMainVariant);
    stickyVariantOptions.appendChild(clone);
  });


  function syncMainVariant(event) {
    const target = event.target;
    const mainSelector = document.querySelector(`[name="${target.name}"]`);
    if (mainSelector) {
      mainSelector.value = target.value;
      mainSelector.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }


let lastScrollPosition = 0; // To store the last scroll position

window.addEventListener('scroll', function() {
  let scrolledPosition = window.scrollY;
  let observedElement = document.querySelector('button#AddToCart.sticky-add-tocart-main');
  let headerElement = document.querySelector('theme-header#header');
  let stickyAddToCart = document.querySelector('.stickyaddtocart');

  if (observedElement && headerElement && stickyAddToCart) {
    let observedElementTop = observedElement.getBoundingClientRect().top + window.scrollY;
    let headerHeight = headerElement.offsetHeight;

    // Check if scrolling down and above the threshold
    if (scrolledPosition > lastScrollPosition && scrolledPosition > (observedElementTop - headerHeight)) {
      stickyAddToCart.classList.add('active');
    } 
    
    // Check if scrolling up
    else if (scrolledPosition < lastScrollPosition) {
      stickyAddToCart.classList.remove('active');
    }

    // Update the last scroll position
    lastScrollPosition = scrolledPosition;
  }
});


function initiateFlicktyInDrawer() {
   
    const blocks = document.querySelectorAll('.icon-block').length;

    if (blocks > 1) {
        document.querySelectorAll('.icons-container .content-wrapper').forEach(wrapper => {
            new Flickity(wrapper, {
                prevNextButtons: false,
                pageDots: false,
                imagesLoaded: true,
                autoPlay: 3000,
                wrapAround: true
            });
        });
    } else {
        document.querySelector('.content-wrapper').classList.add('center');
    }
}
 
    

